import React, { useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { CHUNKED_OTA_AVAILABLE_SINCE, OTA_MIGRATION_DISMISS_KEY } from '../../constants/otaConfig';

const OtaMigrationAlert = () => {
  const [dismissed, setDismissed] = useState(() => (
    localStorage.getItem(OTA_MIGRATION_DISMISS_KEY) === '1'
  ));

  if (dismissed) return null;

  return (
    <Alert variant="warning" className="mt-3 mb-0">
      <strong>First-time OTA setup:</strong>
      {' '}
      Wireless updates require firmware with chunked OTA support (
      {CHUNKED_OTA_AVAILABLE_SINCE}
      ).
      If this device was last programmed before then, use
      {' '}
      <strong>Program Device</strong>
      {' '}
      over USB once before using
      {' '}
      <strong>Send OTA Update</strong>
      .
      <div className="mt-2">
        <Button
          variant="outline-warning"
          size="sm"
          onClick={() => {
            localStorage.setItem(OTA_MIGRATION_DISMISS_KEY, '1');
            setDismissed(true);
          }}
        >
          Got it
        </Button>
      </div>
    </Alert>
  );
};

export default OtaMigrationAlert;